/* eslint-disable prettier/prettier */
import { Link } from 'react-router-dom';
import { ButtonBase, Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const customization = useSelector((state) => state.customization);
    const passwordChanged = customization?.userDetail?.[0]?.user_detail?.change_password;

    return (
        <ButtonBase
            // aria-label="logosection"
            disableRipple
            component={Link}
            to={passwordChanged ? '/dashboard' : undefined} // 👈 redirect only if true
            onDragStart={(e) => e.preventDefault()} // 👈 Prevent drag start
            sx={{
                pointerEvents: passwordChanged ? 'auto' : 'none',
                cursor: passwordChanged ? 'pointer' : 'default',
                height:'80px'
            }}
        >
            <>
                {/* eslint-disable-next-line react/no-unknown-property */}
                <img fetchpriority="high" src="/Logo.v1.webp" alt="QuickCheck" width="60" height="60" draggable="false" />
                <Divider className="MarginTop2px MarginBottom10px gradient-divider-sidebar" />
            </>
        </ButtonBase>
    );
};
LogoSection.propTypes = {
    isLoading: PropTypes.bool
};
export default LogoSection;
